import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_423: DocMigration = {
  maxSchemaVersion: "0.0.423",
  description: "Change default camera key to topRightPerspectiveCamera",
  apply(json: any) {
    if (json.viewports === undefined) {
      return json;
    }
    for (const viewport of Object.values(json.viewports) as any[]) {
      if (viewport.viewType === "VIEW_3D" && viewport.contentSourceId === "defaultExteriorCamera") {
        viewport.contentSourceId = "topRightPerspectiveCamera";
      }
    }
    // Note that this migration is not handling the content source id that can be stored in parameter values. That's fixed in migration 436.
    return json;
  },
};

export default migration_0_0_423;
